import { render, staticRenderFns } from "./2_006_qzfy.vue?vue&type=template&id=92001164"
import script from "./2_006_qzfy.vue?vue&type=script&lang=js"
export * from "./2_006_qzfy.vue?vue&type=script&lang=js"
import style0 from "./2_006_qzfy.vue?vue&type=style&index=0&id=92001164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports